import React, { useMemo, useState } from "react";
import { Container, Row, Col, Card, Form, Button, Alert, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ContactSales = () => {
  const navigate = useNavigate();

  const salesPhone = useMemo(() => "+91 97337 2 1111", []);
  const theme = useMemo(
    () => ({
      bg: "#f6f8fb",
      surface: "#ffffff",
      ink: "#0f172a",
      muted: "#64748b",
      border: "#e5e7eb",
      accent2: "#0ea5e9",
      shadowSoft: "0 12px 24px rgba(2, 6, 23, 0.06)",
    }),
    []
  );

  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "TeaSof ERP - Pricing / Sales Inquiry",
    message: "",
  });

  const onChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    // TODO: connect to backend/email service
  };

  return (
    <div style={{ background: theme.bg, minHeight: "100vh", padding: "30px 0" }}>
      <Container>
        <Row className="align-items-center mb-3">
          <Col>
            <h2 style={{ margin: 0, fontWeight: 900, color: theme.ink }}>Contact Sales</h2>
            <p style={{ marginTop: 8, color: theme.muted, lineHeight: 1.7 }}>
              Pricing, deployment, customization, and implementation support.
            </p>
          </Col>
          <Col className="text-lg-end mt-3 mt-lg-0">
            <Button variant="outline-primary" onClick={() => navigate("/teasof")}>
              ← Back to TeaSof
            </Button>
          </Col>
        </Row>

        <Row className="g-4">
          <Col lg={5}>
            <Card style={{ border: `1px solid ${theme.border}`, borderRadius: 18, boxShadow: theme.shadowSoft }}>
              <Card.Body style={{ padding: 20 }}>
                <div className="d-flex align-items-center justify-content-between">
                  <h5 style={{ fontWeight: 900, color: theme.ink, margin: 0 }}>Sales Hotline</h5>
                  <Badge bg="info" style={{ background: theme.accent2, borderRadius: 999, fontWeight: 900 }}>
                    Priority
                  </Badge>
                </div>

                <p style={{ marginTop: 10, color: theme.muted, lineHeight: 1.7 }}>
                  Call us directly for faster assistance:
                </p>

                <div style={{ fontSize: 20, fontWeight: 900 }}>
                  <a href={`tel:${salesPhone.replace(/\s/g, "")}`} style={{ textDecoration: "none" }}>
                    {salesPhone}
                  </a>
                </div>

                <hr />

                <p style={{ color: theme.muted, lineHeight: 1.7, marginBottom: 0 }}>
                  Typical topics: pricing, rollout plan, data migration, Android deployment and weighing scale integration.
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={7}>
            <Card style={{ border: `1px solid ${theme.border}`, borderRadius: 18, boxShadow: theme.shadowSoft }}>
              <Card.Body style={{ padding: 20 }}>
                {submitted && (
                  <Alert variant="success" style={{ borderRadius: 14 }}>
                    ✅ Thanks! Sales will contact you soon.
                  </Alert>
                )}

                <Form onSubmit={onSubmit}>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control name="name" value={form.name} onChange={onChange} required />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Phone</Form.Label>
                        <Form.Control name="phone" value={form.phone} onChange={onChange} required />
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" name="email" value={form.email} onChange={onChange} />
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Subject</Form.Label>
                        <Form.Control name="subject" value={form.subject} onChange={onChange} />
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Message</Form.Label>
                        <Form.Control as="textarea" rows={4} name="message" value={form.message} onChange={onChange} placeholder="Tell us your requirement and number of gardens/users." />
                      </Form.Group>
                    </Col>

                    <Col md={12} className="d-flex gap-2 flex-wrap mt-2">
                      <Button type="submit" variant="primary" style={{ fontWeight: 900 }}>
                        Send to Sales
                      </Button>
                      <Button
                        type="button"
                        variant="outline-secondary"
                        onClick={() => window.open(`tel:${salesPhone.replace(/\s/g, "")}`, "_self")}
                      >
                        Call Now
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactSales;
